import { Directive, inject, Input } from '@angular/core';
import { PermissionService } from '../services/permission.service';
import { Observable, of, switchMap } from 'rxjs';
import { transformString, UpdateViewBase } from '../common/update-view.base';

@Directive({
  standalone: true,
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[permission]',
})
export class PermissionDirective extends UpdateViewBase {
  protected permissionService = inject(PermissionService);

  @Input()
  set permission(value: string) {
    this.updateView(value);
  }

  checkFn$(permissions: string): Observable<boolean> {
    return this.permissionService.checkPermission$(permissions);
  }
}

@Directive({
  standalone: true,
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[permissionFalse]',
})
export class PermissionFalseDirective extends UpdateViewBase {
  protected permissionService = inject(PermissionService);

  @Input()
  set permissionFalse(value: string) {
    this.updateView(value);
  }

  checkFn$(permissions: string): Observable<boolean> {
    return this.permissionService
      .checkPermission$(permissions)
      .pipe(switchMap((valid) => of(!valid)));
  }
}

@Directive({
  standalone: true,
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[permissionEvery]',
})
export class PermissionEveryDirective extends UpdateViewBase {
  protected permissionService = inject(PermissionService);

  @Input({ transform: transformString })
  set permissionEvery(value: string[]) {
    this.updateView(value);
  }

  checkFn$(permissions: string[]): Observable<boolean> {
    return this.permissionService.checkEveryPermission$(permissions);
  }
}

@Directive({
  standalone: true,
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[permissionSome]',
})
export class PermissionSomeDirective extends UpdateViewBase {
  protected permissionService = inject(PermissionService);

  @Input({ transform: transformString })
  set permissionSome(value: string[]) {
    this.updateView(value);
  }

  checkFn$(permissions: string[]): Observable<boolean> {
    return this.permissionService.checkSomePermissions$(permissions);
  }
}

@Directive({
  standalone: true,
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[permissionSingleOrEvery]',
})
export class PermissionSingleOrEvery extends UpdateViewBase {
  protected permissionService = inject(PermissionService);

  @Input()
  set permissionSingleOrEvery(value: string | string[]) {
    this.updateView(value);
  }

  checkFn$(permissions: string | string[]): Observable<boolean> {
    return this.permissionService.checkSingleOrEveryPermission$(permissions);
  }
}
